import { appstr } from "@coreapp/utils/appstr";
import { Icon, Pill, PillWrapper } from "@theorgchartdev/storybook";

export const BudgetStatus = {
  overbudget: "overbudget",
  underbudget: "underbudget"
};

export const BudgetStatusIcons = {
  [BudgetStatus.overbudget]: { name: "arrow-up-regular", modifier: "error" },
  [BudgetStatus.underbudget]: { name: "arrow-down-regular", modifier: "success" }
};

export const BudgetStatusPillColors = {
  [BudgetStatus.overbudget]: {
    color: "var(--txt-error-primary)",
    backgroundColor: "var(--bg-error-secondary)",
    borderColor: "var(--border-error)"
  },
  [BudgetStatus.underbudget]: {
    color: "var(--txt-success-primary)",
    backgroundColor: "var(--bg-success-secondary)",
    borderColor: "var(--border-success)"
  }
};

export const BudgetStatusPill = props => {
  const { status } = props;
  if (!status) {
    return null;
  }

  return (
    <PillWrapper>
      <Pill
        className="oc-relative"
        label={appstr(status).toLocaleLowerCase()}
        pillColors={BudgetStatusPillColors[status]}
        leftContent={<Icon {...BudgetStatusIcons[status]} size={"small"} />}
      />
    </PillWrapper>
  );
};
